import axios, { AxiosResponse } from 'axios';
import { IhostspotRequest } from '../../types/hotspot';

export const FEEDBACK = `/feedback`;
export const HOTSPOT = `/hotspot`;

export const createFeedback = (data?: any): Promise<AxiosResponse<any>> => {
    return axios.post(FEEDBACK, data);
};

export const getFeedback = (fsn?: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${FEEDBACK}/product/${fsn}`);
};

export const deleteHotspot = (id?: string): Promise<AxiosResponse<any>> => {
    return axios.delete(`${HOTSPOT}/${id}/delete`);
};

export const deleteFeedback = (id?: string): Promise<AxiosResponse<any>> => {
    return axios.delete(`${FEEDBACK}/${id}`);
};

export const resolveFeedback = (id: string): Promise<AxiosResponse<any>> => {
    return axios.patch(`${FEEDBACK}/${id}/resolve`, {});
};

export const createHotspot = (id: string, request: IhostspotRequest): Promise<AxiosResponse<any>> => {
    return axios.post(`${HOTSPOT}/${id}/create`, request);
};

export const fetchAllHotspotData = (id: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${HOTSPOT}/${id}`);
};

export const fetchHotspotData = (pid: string, id: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${HOTSPOT}/${pid}/${id}`);
};
